import { Typography } from '@material-ui/core';
import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const WrapperForm = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1.5rem;

  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.1);

  p.MuiFormHelperText-root.Mui-error {
    margin-top: 0;
  }
`;

export const WrapperGroupInput = styled.div`
  display: grid;
  grid-template-columns: 1fr 2fr;
  grid-gap: 1.5rem;

  margin-top: 1.5rem;
`;

export const WrapperTitle = styled(Typography)`
  text-transform: uppercase;

  font-weight: 700;
  font-size: 1.2rem;

  margin: 1.5rem 0;
`;

export const WrapperActions = styled.div``;
